import { ReactElement } from "react";
import { IStikeControllerProps } from "../../interfaces/props/IStikeControllerProps";

import classes from "./UI_ITOModuleStikeController.module.css";

/**
 * Компонент нижней панели с контроллерами.
 *
 * @param {IStikeControllerProps} props - Пропсы компонента.
 * @param {ReactNode} props.children - Дочерние элементы-контроллеры.
 * @param {string} [props.className] - Дополнительный класс.
 */
export function UIModuleStikeController(
  props: IStikeControllerProps,
): ReactElement {
  const { children, className } = props;
  return (
    <div className={`${className || ""} ${classes.controllers}`}>
      {children}
    </div>
  );
}
